import React, { useEffect, useState, useRef } from 'react';
import { usePaginacion, Paginacion, FontAwesomeIcon, PiePagina, Ventana } from '../../../Helpers/importacionesComunes'
import { faCircle, faCheckCircle } from '@fortawesome/free-regular-svg-icons';
import { faIdCard, faAt, faEdit, faSort } from '@fortawesome/free-solid-svg-icons';
import { IglesiasMinistro } from './IglesiasMinistro'
import AbmObrero from '../../../abms/Abm-obrero'
import { useContextoGlobal } from '../../../Context/contextoGlobal'
import { EstadisticasMail } from '../componentes/EstadisticasMail'
import { ListadoCelular } from '../componentes/ListadoCelular'
import { CardBody, Card, Typography, Button } from '@material-tailwind/react';
import { ChevronUpDownIcon, ClipboardDocumentListIcon, PencilSquareIcon, CheckCircleIcon, XCircleIcon, DocumentArrowUpIcon, PlusIcon } from '@heroicons/react/24/solid';
import ExportToExcelGeneric from '../../../componentes/exportExcelGeneric';
import { Alert } from "@material-tailwind/react";
import { getRegionBadgeStyle, getRangoBadgeStyle } from '../../ComponentesComunes/identificadoresVisuales';


export const Tabla = ({ registrosAmostrar,
    reinicializar,
    resetearLista,
    obreroSeleccionado,
    setObreroSeleccionado,
    setIsObreroSeleccionado
}) => {

    const { configuracion, paginar, inicializar: inicializarPaginacion } = usePaginacion()
    // Hago una copia de los datos que se reciben para poder modificar el listado a conveniencia
    // y mostrar el listado en base a registrosAmostrar por ejemplo para mostrar los datos ordenados por diferentes criterios
    const [copiaRegistrosaMostrar, setCopiaRegistrosaMostrar] = useState([...registrosAmostrar])
    const [orden, setOrden] = useState(null)
    const [nuevoCampo, setNuevoCampo] = useState(true)
    const [contadorOrden, setContadorOrden] = useState(0)
    const [obreroSeleccionadoCredencial, setObreroSeleccionadoCredencial] = useState(null);
    const [obreroSeleccionadoEstadisticasMail, setObreroSeleccionadoEstadisticasMail] = useState(null)
    const { usuario, esCelular, credenciales, setCredenciales, mostrarCredenciales, filtrosMinistros } = useContextoGlobal()
    const [id_agregado, setId_agregado] = useState(null);

    useEffect(() => {
        const data_mas_selector = registrosAmostrar.map((item) => { return { ...item, seleccion: false } })
        setCopiaRegistrosaMostrar([...data_mas_selector])
        inicializarPaginacion(null, data_mas_selector)
    }, [registrosAmostrar])

    useEffect(() => { // el ordenamiento se maneja con las propiedades orden que almacena el campo por el cual ordenar
        // y nuevoCampo que es un flag que indica si es otro campo o el mismo a la inversa
        // cada vez que se cambia el orden en click de la cabecera se cambia contadorOrden como un trigger 
        ordenarDatos()
    }, [contadorOrden])

    const idsCredencialesSet = React.useMemo(() => {
        return new Set(credenciales.map(c => c.id_obrero));
    }, [credenciales]);

    const puedeSeleccionarCredenciales = filtrosMinistros?.estadoCredencial === 'SI'
    const modoSeleccionCredenciales = mostrarCredenciales && puedeSeleccionarCredenciales

    const ordenarDatos = () => {
        setCopiaRegistrosaMostrar([...registrosAmostrar.sort((a, b) => { return comparacion(a, b) })
        ])
    }

    const funcionOrden = (nombre_campo) => {

        if (orden == nombre_campo) {
            setNuevoCampo(false)
        } else {
            setNuevoCampo(true)
        }

        setOrden(nombre_campo)
        setContadorOrden(contadorOrden + 1)

    }

    const comparacion = (a, b) => {

        switch (orden) {
            case null: return 0
            case 'edad':
            case 'id_region':
            case 'id_distrito':

                if (nuevoCampo == true) {
                    return a[orden] - b[orden]
                } else {
                    if (contadorOrden % 2 == 0) {
                        return b[orden] - a[orden]
                    } else {
                        return a[orden] - b[orden]
                    }
                }
            case 'ult_ascenso':
            case 'f_solicitud':

                const dia_a = Number(a[orden].substring(0, 2));
                const mes_a = Number(a[orden].substring(3, 5));
                const anio_a = Number(a[orden].substring(6, 10));

                const fa = new Date(anio_a, mes_a, dia_a);

                const dia_b = Number(b[orden].substring(0, 2));
                const mes_b = Number(b[orden].substring(3, 5));
                const anio_b = Number(b[orden].substring(6, 10));

                const fb = new Date(anio_b, mes_b, dia_b);

                if (nuevoCampo == true) {
                    return fa - fb
                } else {
                    if (contadorOrden % 2 == 0) {
                        return fb - fa
                    } else {
                        return fa - fb
                    }
                }
            default:

                if (nuevoCampo == true) {
                    return a[orden].localeCompare(b[orden])
                } else {
                    if (contadorOrden % 2 == 0) {
                        return b[orden].localeCompare(a[orden])
                    } else {
                        return a[orden].localeCompare(b[orden])
                    }
                }
        }
    }

    const toggleItemParaCredenciales = (item)=>{
        const yaSeleccionado = credenciales.some(i => i.id_obrero == item.id_obrero)

        if (yaSeleccionado) {
            setCredenciales(credenciales.filter(i => i.id_obrero != item.id_obrero))
            setId_agregado(null)
            return
        }

        setCredenciales([...credenciales, item])
        setId_agregado(item.id_obrero)

        setTimeout(() => {
            setId_agregado(null)
        }, 1000)
    }

    if (esCelular) {
        return <>
            <ListadoCelular datos={copiaRegistrosaMostrar} funcionSeleccion={setObreroSeleccionado} setIsObreroSeleccionado={setIsObreroSeleccionado} />
        </>
    }

    const TABLE_HEAD = ["Nombre", "Dirección", "Provincia", "Localidad", "Email", "Teléfono", "Rango", "Acciones"];
    const badgeClassName = "inline-flex items-center justify-center rounded-full px-2.5 py-1 text-xs font-semibold tracking-wide shadow-sm"

    return <Card className="h-full md:w-[62rem] 2xl:w-full overflow-hidden">
            {copiaRegistrosaMostrar.length > 0 &&
                <div className="flex flex-wrap items-center justify-between gap-3 px-3 pt-3 pb-4 sm:px-4">
                    <Paginacion configuracion={configuracion} paginar={paginar} />
                    <div className='ml-auto flex items-center gap-2'>
                        <ExportToExcelGeneric data={copiaRegistrosaMostrar} fileName="Listado de Ministros" isProvider={true}/>
                        <Button 
                            onClick={() => { setIsObreroSeleccionado(true) }} 
                            variant="outlined" 
                            className='flex items-center gap-2 bg-[#2FB18F] text-white'
                            >
                                <PlusIcon className="h-4 w-4" />
                                Añadir
                        </Button> 
                    </div>
                </div>
            }
            <CardBody className="overflow-x-auto px-0 pt-0 pb-0">
                <table className="table-auto text-left w-full">
                    <thead>
                        <tr>
                            <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50"
                            >
                                <ThTitle title='Nombre' sort orden={orden === 'nombre_obrero'} callback={() => funcionOrden('nombre_obrero')} />
                            </th>
                            {usuario.perfil == 'region' && <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50"
                            >
                                <ThTitle title='Distrito' sort orden={orden === 'id_distrito'} callback={() => funcionOrden('id_distrito')} />
                            </th>}
                            {usuario.perfil == 'sede' && <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50"
                            >
                                <ThTitle title='Región' sort orden={orden === 'id_region'} callback={() => funcionOrden('id_region')} />
                            </th>}
                            {usuario.perfil == 'sede' && <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50"
                            >
                                <ThTitle title='Distrito' sort orden={orden === 'id_distrito'} callback={() => funcionOrden('id_distrito')} />
                            </th>}
                            <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50"
                            >
                                <ThTitle title='Dirección' sort orden={orden === 'direccion'} callback={() => funcionOrden('direccion')} />
                            </th>
                            <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50"
                            >
                                <ThTitle title='Provincia' sort orden={orden === 'provincia'} callback={() => funcionOrden('provincia')} />
                            </th>
                            <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50"
                            >
                                <ThTitle title='Localidad' sort orden={orden === 'localidad'} callback={() => funcionOrden('localidad')} />
                            </th>
                            <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50"
                            >
                                <ThTitle title='E-mail' sort orden={orden === 'email'} callback={() => funcionOrden('email')} />
                            </th>
                            <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50"
                            >
                                <ThTitle title='Teléfono' sort orden={orden === 'telefono'} callback={() => funcionOrden('telefono')} />
                            </th>
                            <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50"
                            >
                                <ThTitle title='Rango' sort orden={orden === 'rango'} callback={() => funcionOrden('rango')} />
                            </th>
                            <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50"
                            >
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="flex justify-between gap-2 font-normal leading-none opacity-70"
                                >
                                    Acciones
                                </Typography>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {copiaRegistrosaMostrar
                            .filter((item, index) => {
                                return index >= configuracion.iIni && index <= configuracion.iFin
                            })
                            .map(
                                (item, index) => {
                                    const isLast = index === copiaRegistrosaMostrar.length - 1;
                                    const classes = isLast
                                        ? "p-4"
                                        : "p-4 border-b border-blue-gray-50";

                                    return (
                                        <>
                                            {item.id_obrero == obreroSeleccionadoCredencial?.id_obrero && <Ventana estiloMas={{ width: '500px' }} titulo={'Iglesias del ministro'} cerrar={() => setObreroSeleccionadoCredencial(null)}>
                                                <IglesiasMinistro ministro={item} />
                                            </Ventana>}
                                            {item.id_obrero == obreroSeleccionadoEstadisticasMail?.id_obrero && <Ventana titulo={'Estadísticas de mails'} cerrar={() => setObreroSeleccionadoEstadisticasMail(null)}>
                                                <EstadisticasMail obrero={obreroSeleccionadoEstadisticasMail}
                                                    finalizar={() => setObreroSeleccionadoEstadisticasMail(null)}
                                                    esModal={true} usuario={usuario} />
                                            </Ventana>}

                                            <tr key={item.id_obrero}>
                                                <td
                                                    className={`${classes} ${modoSeleccionCredenciales ? '' : 'cursor-pointer'} bg-blue-50 relative`}
                                                    onClick={() => {
                                                        if (!modoSeleccionCredenciales) {
                                                            setObreroSeleccionado(item.id_obrero)
                                                            setIsObreroSeleccionado(true)
                                                        }
                                                    }}
                                                >
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal"
                                                    >
                                                        {item.nombre_obrero}
                                                    </Typography>
                                                </td>
                                                {usuario.perfil == 'region' && <td className={classes}>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal opacity-70"
                                                    >
                                                        {item.id_distrito}
                                                    </Typography>
                                                </td>}
                                                {usuario.perfil == 'sede' && <td className={classes}>
                                                    <span className={badgeClassName} style={getRegionBadgeStyle(item.id_region)}>
                                                        {item.id_region}
                                                    </span>
                                                </td>}
                                                {usuario.perfil == 'sede' && <td className={classes}>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal opacity-70"
                                                    >
                                                        {item.id_distrito}
                                                    </Typography>
                                                </td>}
                                                <td className={classes}>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal opacity-70"
                                                    >
                                                        {item.direccion}
                                                    </Typography>
                                                </td>
                                                <td className={classes}>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal"
                                                    >
                                                        {item.provincia}
                                                    </Typography>
                                                </td>
                                                <td className={classes}>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal"
                                                    >
                                                        {item.localidad}
                                                    </Typography>
                                                </td>
                                                <td className={`${classes}`}>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal"
                                                    >
                                                        {item.email}
                                                    </Typography>
                                                </td>
                                                <td className={`${classes}`}>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal"
                                                    >
                                                        {item.telefono}
                                                    </Typography>
                                                </td>
                                                <td className={`${classes} flex flex-col items-start justify-center py-2`}>
                                                    <div className="flex items-center gap-2">
                                                        <span className={badgeClassName} style={getRangoBadgeStyle(item.rango)}>
                                                            {item.rango}
                                                        </span>
                                                        {item.tieneCredencial === 'SI' && <CheckCircleIcon title='Tiene credencial activa' width={24} className="text-blue-200" />}
                                                        {item.tieneCredencial === 'NO' && <XCircleIcon title='Sin credencial' width={24} className="text-red-500" />}
                                                    </div>

                                                    <p className="text-xs text-gray-500 mt-1 italic">
                                                        {item.ult_ascenso}
                                                    </p>
                                                </td>
                                                <td className={classes}>
                                                    <div className="flex items-center justify-center gap-1">
                                                        {!modoSeleccionCredenciales && (
                                                            <>
                                                                <span onClick={() => { setObreroSeleccionadoCredencial(item) }}
                                                                    title="Verificar condición para activar la credencial" className="filas-lista-nw cursor-copy" >
                                                                    <ClipboardDocumentListIcon className="cursor-pointer h-6 w-6"/>
                                                                </span>
                                                                <span onClick={() => { setObreroSeleccionado(item.id_obrero); setIsObreroSeleccionado(true) }}
                                                                    title="Editar los datos del ministro" className="filas-lista-nw cursor-copy" >
                                                                    <PencilSquareIcon className="cursor-pointer h-6 w-6"/>
                                                                </span>
                                                            </>
                                                        )}
                                                        {puedeSeleccionarCredenciales && (
                                                            <span onClick={() => toggleItemParaCredenciales(item) }
                                                                title={idsCredencialesSet.has(item.id_obrero) ? 'Quitar de la lista de impresión de credenciales' : 'Incluir en impresión de credenciales'} className="filas-lista-nw cursor-copy" >
                                                                <DocumentArrowUpIcon 
                                                                    className={`h-6 w-6 transition-colors ${
                                                                        idsCredencialesSet.has(item.id_obrero) 
                                                                            ? 'text-green-600' 
                                                                            : 'text-gray-400 hover:text-blue-500'
                                                                    }`} 
                                                                />
                                                            </span>
                                                        )}
                                                    </div>
                                                    <Mensaje id={item.id_obrero} ultimo_agregado = {id_agregado}/>
                                                </td>

                                            </tr>
                                        </>
                                    );
                                },
                            )}
                    </tbody>
                </table>
            </CardBody>
            {copiaRegistrosaMostrar.length > 0 &&
                <PiePagina>
                    <div className="items-center">
                        <Paginacion configuracion={configuracion} paginar={paginar} />
                    </div>
                </PiePagina>
            }
    </Card>

}

const ThTitle = ({ title, sort, orden, callback }) => {
    return <div className='flex f-col justify-center items-center'>
        <Typography
            variant="small"
            color="blue-gray"
            className="flex justify-between gap-2 font-normal leading-none opacity-70"
        >
            {title}{" "}
            {sort &&
                <ChevronUpDownIcon strokeWidth={2} className={`cursor-pointer ${orden ? 'text-blue-500' : ''} h-4 w-4`} icon={faSort} onClick={callback} />
            }
        </Typography>
    </div>
}

const Mensaje = ({id,ultimo_agregado})=>{

    if(id==ultimo_agregado){
        return <Alert className="w-fit p-4 flex justify-center text-center" color="amber">Ministro agregado</Alert>
    }else{
        return null
    }
}